import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { useDispatch } from 'react-redux';
import { createReduxHistoryContext } from 'redux-first-history';
import createSagaMiddleware from 'redux-saga';
import * as applicationStore from './application';
import * as scheduleStore from './schedule/actions';
import * as templateStore from './templates';
import * as messagingStore from './messaging';
import * as regionCampaignsStore from './settings/regioncampaigns';

const { createReduxHistory, routerMiddleware, routerReducer } =
	createReduxHistoryContext({ history: createBrowserHistory() });

const sagaMiddleware = createSagaMiddleware();

const devToolsConfig = {
	name: 'App',
	actionCreators: {
		...applicationStore.actionCreator,
		...scheduleStore.actionCreator,
		...templateStore.actionCreator,
		...messagingStore.actionCreator,
		...regionCampaignsStore.actionCreator
	}
};

export const store = configureStore({
	reducer: {
		application: applicationStore.reducer,
		schedule: scheduleStore.reducer,
		templates: templateStore.reducer,
		messaging: messagingStore.reducer,
		regionCampaigns: regionCampaignsStore.reducer,
		router: routerReducer
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			thunk: false
		})
			.concat(sagaMiddleware)
			.concat(routerMiddleware),
	devTools: process.env.NODE_ENV === 'production' ? false : devToolsConfig
});

sagaMiddleware.run(applicationStore.saga);
sagaMiddleware.run(scheduleStore.saga);
sagaMiddleware.run(templateStore.saga);
sagaMiddleware.run(regionCampaignsStore.saga);

export type RootState = ReturnType<typeof store.getState>;
export const history = createReduxHistory(store);

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
